var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSignage = function SvgSignage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.65 13.333a.65.65 0 0 1 .096 1.293l-.096.007h-20a.65.65 0 0 1-.096-1.293l.096-.007h20zM17.733 0c.82 0 1.484.664 1.484 1.483v9.167c0 .82-.664 1.483-1.484 1.483H3.567c-.82 0-1.484-.664-1.484-1.483V1.483C2.083.664 2.747 0 3.567 0zm0 1.3H3.567a.183.183 0 0 0-.184.183v9.167c0 .101.082.183.184.183h14.166a.183.183 0 0 0 .184-.183V1.483c0-.1-.082-.183-.184-.183zM9.821 3.97l.386.16.203.09.42.192.427.205.425.214.411.216.197.108.369.21c.583.344.991.644.991.786 0 .157-.494.503-1.171.888l-.386.213-.41.216-.426.213-.428.205-.419.191-.4.173c-.129.054-.252.103-.369.148l-.327.12c-.403.136-.664.179-.664.072V3.713c0-.151.494-.016 1.171.257z"
  })));
};

export default SvgSignage;